<template>
    <div class="page m-invigilate">
        <div class="page-main">
            <div class="page-header">
                <h3>
<!--                    <span>正在进行中的考试</span>-->
                    <i class="el-icon-loading"></i>
                    <tip-label tip="此页面只展示有考生在线，且设置了「摄像头拍照监考」的考试" label="正在进行中的考试" />
                    <b>（共{{examList.length}}个）</b>
                </h3>
                <div class="header-query">
                    <el-input v-model="search.paperName"
                              size="small"
                              placeholder="输入考卷名称"
                              @input="onSearch"
                              clearable
                    />
                </div>
            </div>

            <div class="page-table">
                <data-tables class="form-table"
                             ref="trainTable"
                             :data="examList"
                             :table-props="tableProps"
                             :page-size="20"
                >
                    <!-- column title -->
                    <el-table-column v-for="title in titles" :prop="title.prop" :label="title.label" :key="title.label"
                                     :width="title.width" :min-width="title.minWidth"
                                     align="center"
                                     show-overflow-tooltip
                                     :sortable="title.sortable"
                                     :formatter="title.formatter"
                    >
                    </el-table-column>

                    <!-- column buttons -->
                    <el-table-column :label="$t('c.operation')" align="center">
                        <template #default="{row}">
                            <div class="btn-cell">
                                <i class="nucfont inuc-preview" @click="toExamDetail(row)" :title="$t('c.view')"></i>
                            </div>
                        </template>
                    </el-table-column>
                </data-tables>
            </div>
        </div>

        <transition enter-active-class="animated zoomIn"
                    leave-active-class="animated zoomOutUp">
            <router-view></router-view>
        </transition>
    </div>
</template>

<script>
import {Debounce} from "@/utils"

const INTERVAL = 6 // 请求的轮询频率(s)

export default {
    name: 'invigilateIndex',

    components: {},

    data() {
        return {
            search: {
                paperName: ''
            },
            examList: [],
            titles: [
                {
                    prop: 'paperName',
                    label: this.$t('count.examName')
                }, {
                    prop: 'TrainingName',
                    label: this.$t('train.name')
                }, {
                    prop: 'onlineUserCount',
                    label: '在线人数',
                    sortable: 'custom'
                }, {
                    prop: 'photoDuration',
                    label: '监考拍照频率',
                    formatter(row, column, cellValue, index) {
                        return `${row.photoDuration} 秒/次`
                    }
                }
            ],
            tableProps: {
                border: true,
                stripe: true,
                height: "auto"
            },
        }
    },

    computed: {

    },

    mounted() {
        this.getProcessingExam()

        this.initLoop()
    },

    beforeDestroy() {
        this.interval && clearInterval(this.interval)
    },

    methods: {
        getProcessingExam() {
            this.$api.getProcessingExam(this.search).then(res => {
                this.examList = res.package
            })
        },

        toExamDetail({id}) {
            this.$router.push({name: 'invigilateDetail', params: {id}})
        },

        onSearch: Debounce(function () {
            this.getProcessingExam()
        }, 300),

        initLoop() {
            this.interval = setInterval(() => {
                this.getProcessingExam()
            }, INTERVAL*1000)
        }
    },
}
</script>

<style scoped lang="scss">
.m-invigilate {

}

.page-main {
    height: 100%;
    display: flex;
    flex-direction: column;
    background-color: #fff;
}

.page-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 20px 30px 10px 30px;

    h3 {
        font-size: 15px;
        color: #666;
        font-weight: 600;

        span {
            margin-left: 2px;
        }
    }

    b {
        color: $blue;
    }
}

.page-table {
    box-shadow: none;
}
</style>
